import React from "react";

export const STATUS_LABEL = {
  bestaetigung_ausstehend: "Bestätigung ausstehend",
  entwurf: "Entwurf", geprueft: "Geprüft", bereit: "Bereit", geplant: "Geplant",
  ueberfaellig: "Überfällig",
  veroeffentlicht: "Veröffentlicht", fehler: "Fehler", blockiert: "Blockiert",
};
export const EDITABLE_STATUS_LABEL = Object.fromEntries(
  Object.entries(STATUS_LABEL).filter(([status]) => !["ueberfaellig", "bestaetigung_ausstehend"].includes(status))
);
const STATUS_CLASS = {
  bestaetigung_ausstehend: "bg-sky-50 text-sky-700 border-sky-200",
  entwurf: "bg-slate-100 text-slate-700 border-slate-300",
  geprueft: "bg-blue-50 text-blue-700 border-blue-200",
  bereit: "bg-emerald-50 text-emerald-700 border-emerald-200",
  geplant: "bg-amber-50 text-amber-700 border-amber-200",
  ueberfaellig: "bg-orange-100 text-orange-800 border-orange-300",
  veroeffentlicht: "bg-indigo-50 text-indigo-700 border-indigo-200",
  fehler: "bg-rose-50 text-rose-700 border-rose-200",
  blockiert: "bg-red-100 text-red-800 border-red-300",
};

export function effectivePostStatus(post) {
  if (!post) return undefined;
  if (post.status === "geplant" && !post.published_at && !post.external_post_id && post.scheduled_at) {
    const scheduled = new Date(post.scheduled_at);
    if (!Number.isNaN(scheduled.getTime()) && scheduled.getTime() < Date.now()) {
      return post.mode === "manual" ? "bestaetigung_ausstehend" : "ueberfaellig";
    }
  }
  return post.display_status || post.status;
}

export function StatusBadge({ status, post }) {
  const shownStatus = post ? effectivePostStatus(post) : status;
  return (
    <span data-testid={`post-status-badge-${shownStatus}`}
      className={`inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-medium border ${STATUS_CLASS[shownStatus] || STATUS_CLASS.entwurf}`}>
      {STATUS_LABEL[shownStatus] || shownStatus}
    </span>
  );
}

export const MODE_LABEL = {
  simulation: "Simulation",
  assisted: "Assistiert",
  api: "API-Automatik",
  manual: "Manuell / extern",
};
const MODE_DOT = {
  simulation: "bg-purple-500",
  assisted: "bg-blue-500",
  api: "bg-emerald-500",
  manual: "bg-slate-500",
};

export function ModeBadge({ mode }) {
  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-sm text-xs font-medium bg-white border border-slate-200 text-slate-700">
      <span className={`h-1.5 w-1.5 rounded-full ${MODE_DOT[mode] || "bg-slate-400"}`} />
      {MODE_LABEL[mode] || mode}
    </span>
  );
}

export const PLATFORM_LABEL = {
  tiktok: "TikTok", instagram: "Instagram", facebook: "Facebook", linkedin: "LinkedIn", youtube: "YouTube",
};

export function PlatformBadge({ platform }) {
  const colors = {
    tiktok: "bg-black text-white", instagram: "bg-gradient-to-br from-fuchsia-500 to-orange-400 text-white",
    facebook: "bg-blue-600 text-white", linkedin: "bg-sky-700 text-white", youtube: "bg-red-600 text-white",
  };
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-semibold ${colors[platform] || "bg-slate-200 text-slate-700"}`}>
      {PLATFORM_LABEL[platform] || platform || "?"}
    </span>
  );
}
